import React from 'react';
import DOMPurify from 'dompurify';

/**
 * Safely renders HTML content with proper styling
 * Use this to display content from the rich text editor
 */
const RichTextContent = ({ content, className = "", testId, preview = false }) => {
  if (!content) return null;
  const html = /<[a-z][\s\S]*>/i.test(content) ? content : content.replace(preview ? /\n+/g : /\n/g, '<br>');
  const out = preview ? html.replace(/(<br\s*\/?>\s*)+/gi, '<br>') : html;

  return (
    <div 
      data-testid={testId}
      className={`prose prose-gray max-w-none ${className}`}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(out) }}
      style={{
        whiteSpace: 'normal',
      }}
    />
  );
};

export default RichTextContent;
